function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#6D7481"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.5521 5.14378C11.3121 5.34645 10.9894 5.44778 10.5841 5.44778C10.2108 5.44778 9.90142 5.34645 9.65609 5.14378C9.41075 4.94111 9.28809 4.66911 9.28809 4.32778C9.28809 3.96511 9.41075 3.68245 9.65609 3.47978C9.90142 3.27711 10.2108 3.17578 10.5841 3.17578C10.9894 3.17578 11.3121 3.27711 11.5521 3.47978C11.7921 3.68245 11.9121 3.96511 11.9121 4.32778C11.9121 4.66911 11.7921 4.94111 11.5521 5.14378ZM9.35187 15.0876C9.13854 15.125 8.93588 15.1436 8.74388 15.1436C8.33854 15.1436 8.05854 15.0663 7.90387 14.9116C7.74921 14.757 7.67188 14.589 7.67188 14.4076C7.67188 14.1943 7.68787 13.9863 7.71988 13.7836C7.75187 13.581 7.79454 13.357 7.84787 13.1116L8.93588 8.15162L7.94388 7.92762V7.38362C8.10388 7.31962 8.31721 7.25295 8.58388 7.18362C8.85054 7.11428 9.13321 7.05295 9.43187 6.99962C9.73054 6.94628 10.0265 6.90095 10.3199 6.86362C10.6132 6.82628 10.8719 6.80762 11.0959 6.80762L11.3839 6.99962L9.94388 13.8956H11.0639V14.4396C10.9252 14.5356 10.7625 14.6263 10.5759 14.7116C10.3892 14.797 10.1919 14.8716 9.98388 14.9356C9.77588 14.9996 9.56521 15.0503 9.35187 15.0876Z",
  fill: "white"
});

function SvgInfoCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.06b3bd4f.svg";
export { ForwardRef as ReactComponent };